import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "About", href: "#about" },
  { label: "Pricing", href: "#pricing" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#22262B]/85 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => go("#home")}
          className="flex items-center group"
        >
          <img
            src="/logo.jpg"
            alt="GoGoAuto Mobile Repair & Service"
            data-testid="header-logo-img"
            className="h-11 w-auto rounded-sm transition-transform duration-300 group-hover:scale-105"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-mist hover:text-ember transition-colors duration-200 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-book-btn"
            onClick={() => go("#booking")}
            className="hidden sm:inline-flex bg-ember text-obsidian font-display font-bold uppercase tracking-wider text-base px-5 py-2 rounded-sm hover:bg-[#9BE873] hover:shadow-[0_0_24px_rgba(132,220,90,0.4)] transition-all duration-200"
          >
            Book Service
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#22262B]/95 backdrop-blur-md" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.href)}
              className="block w-full text-left px-6 py-4 text-mist hover:text-ember font-display uppercase tracking-wider text-lg border-b border-white/5"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
